import { render, staticRenderFns } from "./PrintResumeAccountsReceivableClient2.vue?vue&type=template&id=7b2f5c52&scoped=true"
import script from "./PrintResumeAccountsReceivableClient2.vue?vue&type=script&lang=js"
export * from "./PrintResumeAccountsReceivableClient2.vue?vue&type=script&lang=js"
import style0 from "./PrintResumeAccountsReceivableClient2.vue?vue&type=style&index=0&id=7b2f5c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2f5c52",
  null
  
)

export default component.exports